// ** React Imports
import React from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// ** Utils & Helpers
import { searchSexCustomSort } from "utils/searchSexCustomSort";

// #####################################################

const SearchInfo = ({ user }) => {
	const { t } = useTranslation([
		"common",
		"filtersAndSelectors",
		"userProfile",
	]);

	// ** A/B TESTS: New Purpose
	const userId = useSelector((state) => state.global.user.id);
	const newPurpose = userId % 2 === 1;

	const userSearchForArrayFiltered = newPurpose
		? user.searchForArray.filter(
				(item) => item !== "sponsored_arrangement" && item !== "fun"
		  )
		: user.searchForArray.filter((item) => item !== "one_time");

	// #####################################################

	return (
		<>
			<Block
				pt={
					!user.descriptionObject?.plain &&
					user?.listOfLinksArray?.length === 0
						? 0
						: 6
				}
			>
				<Text bold size="1.25rem">
					{t("userProfile:looking")}
				</Text>
			</Block>
			<Block>
				{user.searchSexArray.length !== 0 && (
					<Block>
						<Text>{t("userProfile:for")}:</Text>{" "}
						<Text bold>
							{[...user.searchSexArray]
								.filter((item) => item !== null)
								.sort(searchSexCustomSort)
								.map((item) => t(`common:sexOptions.${item}`))
								.join(", ")}
						</Text>
					</Block>
				)}
				{userSearchForArrayFiltered.length !== 0 && (
					<Block>
						<Text>{t("userProfile:purpose")}:</Text>{" "}
						<Text bold>
							{userSearchForArrayFiltered
								.filter((item) => item !== null)
								.map((item) =>
									t(`filtersAndSelectors:purpose.${item}`)
								)
								.join(", ")}
						</Text>
					</Block>
				)}
				{(user.searchAgeObject.from !== null ||
					user.searchAgeObject.to !== null) && (
					<Block>
						<Text>{t("userProfile:aged")}:</Text>{" "}
						<Text bold>
							{user.searchAgeObject.from !== null &&
								`${t("common:from")} ${
									user.searchAgeObject.from
								}`}{" "}
							{user.searchAgeObject.to !== null &&
								`${t("common:to")} ${
									user.searchAgeObject.to
								}`}{" "}
							{t("common:years")}
						</Text>
					</Block>
				)}
			</Block>
		</>
	);
};

// #####################################################

export default SearchInfo;

// #####################################################
